export default [
  {
    key: 'IOS',
    value: 'iOS',
    id: 'IOS',
    children: [
      {
        key: 'IOS_VERSION_4',
        value: 'iOS 4.x',
        id: 'IOS_VERSION_4'
      },
      {
        key: 'IOS_VERSION_5',
        value: 'iOS 5.x',
        id: 'IOS_VERSION_5'
      },
      {
        key: 'IOS_VERSION_6',
        value: 'iOS 6.x',
        id: 'IOS_VERSION_6'
      },
      {
        key: 'IOS_VERSION_7',
        value: 'iOS 7.x',
        id: 'IOS_VERSION_7'
      },
      {
        key: 'IOS_VERSION_8',
        value: 'iOS 8.x',
        id: 'IOS_VERSION_8'
      },
      {
        key: 'IOS_VERSION_9',
        value: 'iOS 9.x',
        id: 'IOS_VERSION_9'
      },
      {
        key: 'IOS_VERSION_10',
        value: 'iOS 10.x',
        id: 'IOS_VERSION_10'
      },
      {
        key: 'IOS_VERSION_11',
        value: 'iOS 11.x',
        id: 'IOS_VERSION_11'
      },
      {
        key: 'IOS_VERSION_12',
        value: 'iOS 12.x',
        id: 'IOS_VERSION_12'
      },
      {
        key: 'IOS_VERSION_13',
        value: 'iOS 13.x',
        id: 'IOS_VERSION_13'
      },
      {
        key: 'IOS_VERSION_14',
        value: 'iOS 14.x',
        id: 'IOS_VERSION_14'
      },
      {
        key: 'IOS_VERSION_15',
        value: 'iOS 15.x',
        id: 'IOS_VERSION_15'
      },
      {
        key: 'IOS_VERSION_16',
        value: 'iOS 16.x',
        id: 'IOS_VERSION_16'
      },
      {
        key: 'IOS_VERSION_17',
        value: 'iOS 17.x',
        id: 'IOS_VERSION_17'
      },
      {
        key: 'IOS_VERSION_18',
        value: 'iOS 18.x',
        id: 'IOS_VERSION_18'
      }
    ]
  }
]
